module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pbba",
    attrs: {
      "id": "calibre_pb_6"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lgl"
  }, [_c('h1', {
    staticClass: "nobreak",
    attrs: {
      "id": "calibre_toc_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_1"
    }
  }), _vm._v("    PART ONE   "), _c('br', {
    staticClass: "sub-head"
  }), _vm._v(" "), _c('span', {
    staticClass: "lgl"
  }, [_vm._v("Red and Black Laughter")])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote30em"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "it"
  }, [_vm._v("The only source of the true Ridiculous (as it appears to me) is\naffectation.")])]), _vm._v(" "), _c('p', {
    staticClass: "line6"
  }, [_vm._v("HENRY FIELDING")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95ce53d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/20210135e_split_006.vue
// module id = 66
// module chunks = 0